import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { PainQuestionnaireItem } from './questionnaire'

export const PAIN_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [PainQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_STATUS]: QuestionnaireAnswerType.STRING,
  [PainQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_GOAL]: QuestionnaireAnswerType.STRING,
  [PainQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_FACE]: QuestionnaireAnswerType.STRING,
  [PainQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_LEGS]: QuestionnaireAnswerType.STRING,
  [PainQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_ACTIVITY]:
    QuestionnaireAnswerType.STRING,
  [PainQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_CRY]: QuestionnaireAnswerType.STRING,
  [PainQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_FLACC_SCALE_CONSOLABILITY]:
    QuestionnaireAnswerType.STRING,
  [PainQuestionnaireItem.MEDICAL_BACKGROUND_PAIN_SYSTEM_SUMMARY]: QuestionnaireAnswerType.STRING
}
